import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const FormsPage = lazy(() => import('./pages/FormsPage'));

export const FormsRoutes: RouteObject = {
  path: 'forms',
  children: [
    { path: '', element: <FormsPage />, handle: { crumb: 'Forms & Conversion Funnels' } },
  ],
};
